 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc":"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc","metrics":"metrics","account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75":"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d","account":"account","browse-book":"browse-book","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-oneshot":"browse-oneshot","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","duplicate-files":"duplicate-files","duplicate-pages":"duplicate-pages","history":"history","home":"home","import-books":"import-books","import-readlist":"import-readlist","login":"login","media-analysis":"media-analysis","read-book":"read-book","search":"search","settings-users":"settings-users","settings-server~settings-user":"settings-server~settings-user","settings-server":"settings-server","settings-user":"settings-user","announcements":"announcements","import~media-management~settings":"import~media-management~settings","import":"import","media-management":"media-management","settings":"settings","notfound":"notfound","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc":"a156b00c","metrics":"4f995f5c","account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75":"e91b37b7","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079":"e8067196","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d":"7cedf422","account":"145b95b0","browse-book":"800289ed","browse-collection":"0a02c021","browse-collections":"18a5e58e","browse-libraries":"e1c525c0","browse-oneshot":"387d9141","browse-readlist":"ce5269a7","browse-readlists":"b38e0cbe","browse-series":"8e04694f","dashboard":"2ed6e415","duplicate-files":"83e57fff","duplicate-pages":"d1f096e7","history":"acbbc466","home":"70e0879d","import-books":"a8c64ff0","import-readlist":"2bf77ce3","login":"905f6327","media-analysis":"5d1068e2","read-book":"93bde872","search":"9fcda469","settings-users":"5b03a6f5","settings-server~settings-user":"b1ec701e","settings-server":"dbf1006b","settings-user":"57550547","announcements":"70b7be4b","import~media-management~settings":"7ec3e399","import":"ea081486","media-management":"7b2eeae1","settings":"cfbb53ad","notfound":"7d231a80","welcome":"f3402b7e","startup":"14ec1a89"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc":1,"metrics":1,"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079":1,"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d":1,"account":1,"browse-book":1,"browse-collection":1,"browse-collections":1,"browse-libraries":1,"browse-oneshot":1,"browse-readlist":1,"browse-readlists":1,"browse-series":1,"dashboard":1,"duplicate-files":1,"duplicate-pages":1,"history":1,"home":1,"import-books":1,"import-readlist":1,"login":1,"media-analysis":1,"read-book":1,"search":1,"settings-users":1,"settings-server~settings-user":1,"settings-user":1,"announcements":1,"import~media-management~settings":1,"import":1,"media-management":1,"settings":1,"notfound":1,"welcome":1,"startup":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc":"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc","metrics":"metrics","account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75":"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d":"account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d","account":"account","browse-book":"browse-book","browse-collection":"browse-collection","browse-collections":"browse-collections","browse-libraries":"browse-libraries","browse-oneshot":"browse-oneshot","browse-readlist":"browse-readlist","browse-readlists":"browse-readlists","browse-series":"browse-series","dashboard":"dashboard","duplicate-files":"duplicate-files","duplicate-pages":"duplicate-pages","history":"history","home":"home","import-books":"import-books","import-readlist":"import-readlist","login":"login","media-analysis":"media-analysis","read-book":"read-book","search":"search","settings-users":"settings-users","settings-server~settings-user":"settings-server~settings-user","settings-server":"settings-server","settings-user":"settings-user","announcements":"announcements","import~media-management~settings":"import~media-management~settings","import":"import","media-management":"media-management","settings":"settings","notfound":"notfound","welcome":"welcome","startup":"startup"}[chunkId]||chunkId) + "." + {"account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~0af3cadc":"89f6eace","metrics":"f23869cd","account~announcements~browse-book~browse-collection~browse-collections~browse-libraries~browse-onesh~f7bb7b75":"8900c3e4","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~a20a4079":"8902e022","account~browse-book~browse-collection~browse-collections~browse-libraries~browse-oneshot~browse-read~9b13306d":"c3dd432d","account":"0686bb0c","browse-book":"b966696e","browse-collection":"19989c28","browse-collections":"e7d190e1","browse-libraries":"21c24e57","browse-oneshot":"b966696e","browse-readlist":"62b11503","browse-readlists":"e7d190e1","browse-series":"0d591163","dashboard":"818c0b1d","duplicate-files":"dc43750a","duplicate-pages":"ccce73bf","history":"29734d0c","home":"14fece21","import-books":"8dece440","import-readlist":"997a0311","login":"323dcdba","media-analysis":"dc43750a","read-book":"966bc2df","search":"d3828777","settings-users":"69f8bb64","settings-server~settings-user":"12f8780e","settings-server":"31d6cfe0","settings-user":"cb2bc26a","announcements":"97b4bcfa","import~media-management~settings":"7df717b5","import":"878ad2e3","media-management":"df1b70ce","settings":"df1b70ce","notfound":"5cff8ae2","welcome":"7cc5818c","startup":"7cc5818c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
